import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-count-card',
    templateUrl: './count-card.component.html',
    styleUrls: ['./count-card.component.css']
})
export class CountCardComponent implements OnInit {
    @Input() text: string;
    @Input() totalCount: number;
    @Input() textHexColor: string;
    @Input() backgroundColor: boolean;

    constructor() {}

    ngOnInit(): void {}
}
